export default __webpack_public_path__ + "static/media/customer1.3921a599.png";